import get from 'lodash/get';
import values from 'lodash/values';
import { tagValidations, type QnAStateType, type TagsType, type Validation, type ValidationType } from '../index';
export const getQuestions = (state: QnAStateType, {
  withoutVirtualAnswer
}: {
  withoutVirtualAnswer?: boolean;
} = {
  withoutVirtualAnswer: true
}) => {
  if (withoutVirtualAnswer) {
    return values(state.questions).reduce((p, question) => {
      const strippedQuestion = {
        ...question,
        answers: question.answers.filter(answer => !answer.virtual)
      };
      p[strippedQuestion.id] = strippedQuestion;
      return p;
    }, {});
  }
  return state.questions;
};
export const getQuestionById = (state: QnAStateType, questionId: string) => get(state, `questions.${questionId}`);
export const getTopQuestionIds = (state: QnAStateType) => state.topQuestionIds;
export const getIsTopLevel = (state: QnAStateType, questionId: string) => getTopQuestionIds(state).includes(questionId);
export const getQuestionNameById = (state: QnAStateType, questionId: string) => {
  const question = getQuestionById(state, questionId);
  return get(question, 'question');
};
export const getQuestionValidations = (state: QnAStateType, questionId: string): Array<Validation> => {
  const question = getQuestionById(state, questionId);
  const tagValidations = getAllValidationFromTags(question.tags);
  return [...(question.validations ?? []), ...tagValidations];
};
export const getQuestionValidationOfType = (state: QnAStateType, questionId: string, type: ValidationType) => {
  return getQuestionValidations(state, questionId).find(value => value.type === type);
};
export const getValidationFromTags = (tags: TagsType, type: ValidationType) => {
  return tags.find(tag => tag.includes(type));
};
export const createValidationTag = (type: ValidationType, value = '') => {
  return `${type}::${value}`;
};
export const getValidationTypeAndValue = (tag: String) => {
  const [type, value] = tag.split('::');
  if (!tag || !type) {
    return null;
  }
  return {
    type,
    value
  };
};
export const getAllValidationFromTags = (tags: TagsType) => {
  return tags.filter(tag => tagValidations.some(type => tag.includes(type))).map(tag => getValidationTypeAndValue(tag)).filter(tag => !!tag);
};